import { createStore, createHook, createContainer } from '@atlassian/react-sweet-state';
import actions, { type Actions } from './actions';
import {
	getGroupsResourceStatus,
	getGroupsSelector,
	getTicketTypesResource,
	getTicketTypesByGroupId,
	getGroupIdsByTicketTypeId,
	getTicketTypesByPractices,
	isLastGroupSelector,
	isNewestGroupSelector,
} from './selectors';
import type { State, ContainerProps } from './types';

const INITIAL_STATE: State = {
	groups: {
		error: null,
		loading: true,
		data: [],
	},
	ticketTypes: {
		error: null,
		loading: true,
		data: {},
	},
	ticketTypesByGroup: {},
	groupsByTicketType: {},
	ticketTypesByPractice: {},
};

export const Store = createStore<State, Actions>({
	initialState: INITIAL_STATE,
	actions,
	name: 'portal-request-groups-state',
});

// Splitting up group resource status(loading & error) from group list data because
// list data changes are volatile. We don't want to trigger subscribers of
// loading and error because the group list changes
export const useGroupsResourceStatusSubscriber = createHook(Store, {
	selector: getGroupsResourceStatus,
});

export const useGroupsSubscriber = createHook(Store, {
	selector: getGroupsSelector,
});

export const useTicketTypesSubscriber = createHook(Store, {
	selector: getTicketTypesResource,
});

export const useTicketTypesByGroupIdSubscriber = createHook(Store, {
	selector: getTicketTypesByGroupId,
});

export const useGroupIdsByTicketTypeIdSubscriber = createHook(Store, {
	selector: getGroupIdsByTicketTypeId,
});

export const useTicketTypesByPracticesSubscriber = createHook(Store, {
	selector: getTicketTypesByPractices,
});

export const useIsLastGroupSubscriber = createHook(Store, {
	selector: isLastGroupSelector,
});

export const useIsNewestGroupSubscriber = createHook(Store, {
	selector: isNewestGroupSelector,
});

const useStoreActions = createHook(Store, {
	selector: null,
});

export const useActionsProvider = () => {
	const [, storeActions] = useStoreActions();
	return storeActions;
};

export default createContainer<State, Actions, ContainerProps>(Store);
